import {Component, Input, OnInit} from '@angular/core';
import {NextLessonData, ReworkLesson} from "../../../../types/interfaces";

@Component({
  selector: 'app-lesson-practice',
  templateUrl: './practice.component.html',
  styleUrls: ['./practice.component.scss'],
})
export class PracticeComponent  implements OnInit {

    @Input() class: string = '';
    @Input() isTransferredLesson: boolean = false;
    @Input() lesson: NextLessonData;
    @Input() lessonStart: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
